<template>
    <div class="color_picker">
        <div>
            <div
                @click="colorPickerVisible = !colorPickerVisible"
                class="color_picker-trigger"
                :class="colorPickerVisible ? 'active' : ''"
            >
                <span>#{{ getPageColor.hex }}</span>
                <div
                    style="width: 30%; height: 15px; margin: 0 0 0 auto;"
                    :style="`background-color: #${getPageColor.hex}`"
                />
            </div>
            <div
                class="color_picker-container"
                ref="colorPickerContainer"
                v-show="colorPickerVisible"
            > 
                <div ref="picker_size" style="width: 150px; margin: auto;">
                    <canvas
                        ref="colorPickerBlock"
                        width="150"
                        height="150"
                        @click="(e) => {changeInputColor(e)}"
                        @mousemove="mousemove"
                        @mousedown="mousedown"
                        @mouseup="mouseup"
                    />
                    <div ref="colorPickerPointer"
                        :style="`left: ${pointerPos.x}px; top: ${pointerPos.y}px;`"
                    />
                </div>
                <div ref="spectrum_size" style="width: 150px; margin: 10px auto;">
                    <canvas
                        ref="colorPickerSpectrum"
                        width="150"
                        height="20"
                        @click="(e) => {changeSpectrumColor(e)}"
                    />
                </div>
                <div class="color_picker-values" style="width: 150px;">
                    <div class="hex_input">
                        <span>#</span>
                        <input
                            type="text"
                            v-model="hexColor"
                            @input="onInputChange"
                        />
                    </div>
                    <div class="rgb_input">
                        <span>R <input type="number" v-model.number="rgbColor.r" @input="onRgbInputChange(rgbColor.r, 'red')"/></span>
                        <span>G <input type="number" v-model.number="rgbColor.g" @input="onRgbInputChange(rgbColor.g, 'green')"/></span>
                        <span>B <input type="number" v-model.number="rgbColor.b" @input="onRgbInputChange(rgbColor.b, 'blue')"/></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    export default {
        data() {
            return {
                colorPickerVisible: false,
                isDragActive: false,
                isSpectrumDragActive: false,
                hexColor: undefined,
                rgbColor: {
                    r: undefined,
                    g: undefined,
                    b: undefined,
                    rgb: undefined
                },
                hslColor: {
                    h: undefined,
                    s: undefined,
                    l: undefined
                },
                hueColor: undefined,
                width: 150,
                height: 150,
                ctx: undefined,
                pointerPos: {
                    x: undefined,
                    y: undefined
                }
            }
        },
        methods: {
            createColorPickerSpectrum() {
                const colorPicker = this.$refs.colorPickerContainer;
                const colorPickerSpectrum = this.$refs.colorPickerSpectrum;
                const spectrumCtx = colorPickerSpectrum.getContext('2d');

                const spectrumWidth = this.$refs.colorPickerSpectrum.width;
                const spectrumHeight = this.$refs.colorPickerSpectrum.height;
                spectrumCtx.rect(0, 0, spectrumWidth, spectrumHeight);

                let spectrumGradient = spectrumCtx.createLinearGradient(0, 0, spectrumWidth, 0);
                spectrumGradient.addColorStop(0, 'rgba(255, 0, 0, 1)');
                spectrumGradient.addColorStop(0.17, 'rgba(255, 255, 0, 1)');
                spectrumGradient.addColorStop(0.34, 'rgba(0, 255, 0, 1)');
                spectrumGradient.addColorStop(0.51, 'rgba(0, 255, 255, 1)');
                spectrumGradient.addColorStop(0.68, 'rgba(0, 0, 255, 1)');
                spectrumGradient.addColorStop(0.85, 'rgba(255, 0, 255, 1)');
                spectrumGradient.addColorStop(1, 'rgba(255, 0, 0, 1)');
                spectrumCtx.fillStyle = spectrumGradient;
                spectrumCtx.fill();
            },
            changeSpectrumColor(e) {
                let x = e.offsetX;
                let y = e.offsetY;

                let colorData = this.$refs.colorPickerSpectrum.getContext('2d').getImageData(x, y, 1, 1).data;

                let r =  colorData[0];
                let g =  colorData[1];
                let b =  colorData[2]

                this.rgbColor = {
                    rgb: `rgb(${r}, ${g}, ${b})`,
                    r,
                    g,
                    b
                }
                this.hexColor = this.fullColorHex(r, g, b);

                this.hslColor = {
                    h: this.rgbToHsl(r, g, b).h,
                    s: this.rgbToHsl(r, g, b).s,
                    l: this.rgbToHsl(r, g, b).l
                }
                this.ctx.clearRect(0, 0, this.width, this.height);
                this.renderHSL(this.ctx, this.hslColor.h, this.width, this.height);
                this.pointerPos = {
                    x: this.getDotCoordinates(this.hslColor.s, this.hslColor.l, this.width, this.height).x,
                    y: this.getDotCoordinates(this.hslColor.s, this.hslColor.l, this.width, this.height).y
                }

                this.$store.dispatch('SET_PAGE_COLOR', {
                    rgb: this.rgbColor.rgb,
                    hex: this.hexColor,
                    x: this.pointerPos.x,
                    y: this.pointerPos.y
                })
            },
            hexToRgb(hex) {
                if (hex.charAt(0) === '#') {
                    hex = hex.substr(1);
                }
                if ((hex.length < 2) || (hex.length > 6)) {
                    return false;
                }
                let values = hex.split(''),
                    r,
                    g,
                    b;

                if (hex.length === 2) {
                    r = parseInt(values[0].toString() + values[1].toString(), 16);
                    g = r;
                    b = r;
                } else if (hex.length === 3) {
                    r = parseInt(values[0].toString() + values[0].toString(), 16);
                    g = parseInt(values[1].toString() + values[1].toString(), 16);
                    b = parseInt(values[2].toString() + values[2].toString(), 16);
                } else if (hex.length === 6) {
                    r = parseInt(values[0].toString() + values[1].toString(), 16);
                    g = parseInt(values[2].toString() + values[3].toString(), 16);
                    b = parseInt(values[4].toString() + values[5].toString(), 16);
                } else {
                    return false;
                }

                return this.rgbColor = {
                    rgb: `rgb(${r}, ${g}, ${b})`,
                    r,
                    g,
                    b
                }
            },
            rgbToHex(rgb) {
                let hex = Number(rgb).toString(16);
                if (hex.length < 2) {
                    hex = '0' + hex
                }
                return hex;
            },
            fullColorHex(r, g, b) {
                const red = this.rgbToHex(r);
                const green = this.rgbToHex(g);
                const blue = this.rgbToHex(b);

                return red + green + blue;
            },
            rgbToHsl(r, g, b) {
                r /= 255;
                g /= 255;
                b /= 255;
                
                let max = Math.max(r, g, b);
                let min = Math.min(r, g, b);
                let d = max - min;
                let h;
                if (d === 0) h = 0;
                else if (max === r) h = (g - b) / d % 6;
                else if (max === g) h = (b - r) / d + 2;
                else if (max === b) h = (r - g) / d + 4;
                let l = (min + max) / 2;
                let s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
                // return {
                //     h: h*60,
                //     s,
                //     l
                // };
                return this.hslColor = {
                    h: h*60,
                    s,
                    l
                }
            },
            hslToRgb(h, s, l) {
                let c = (1 - Math.abs(2 * l - 1)) * s;
                let hp = h / 60.0;
                let x = c * (1 - Math.abs((hp % 2) - 1));
                let rgb1;
                if (isNaN(h)) rgb1 = [0, 0, 0];
                else if (hp <= 1) rgb1 = [c, x, 0];
                else if (hp <= 2) rgb1 = [x, c, 0];
                else if (hp <= 3) rgb1 = [0, c, x];
                else if (hp <= 4) rgb1 = [0, x, c];
                else if (hp <= 5) rgb1 = [x, 0, c];
                else if (hp <= 6) rgb1 = [c, 0, x];
                let m = l - c * 0.5;
                return [
                    Math.round(255 * (rgb1[0] + m)),
                    Math.round(255 * (rgb1[1] + m)),
                    Math.round(255 * (rgb1[2] + m))
                ];
            },
            renderHSL(context, hue, width, height) {
                
                const imgData = context.getImageData(0, 0, width, height);
                const pixels = imgData.data;
                let x, y, rgb, o;
                for (y = 0; y < height; y++) { 
                    for (x = 0; x < width; x++) {
                        o = (y * width + x) * 4;
                        rgb = this.hslToRgb(hue, x / width, y / height);
                        if (x == 100 && y == 100) {
                            // console.log(rgb);
                        }
                        pixels[o] = rgb[0];
                        pixels[o+1] = rgb[1];
                        pixels[o+2] = rgb[2];
                        pixels[o+3] = 255;
                    }
                }
                context.putImageData(imgData, 0, 0);
            },
            getDotCoordinates(saturation, lightness, canvasWidth, canvasHeight) {
                var x = saturation * canvasWidth;
                var y = lightness * canvasHeight;
                
                return {
                    x,
                    y
                };
            },
            changeInputColor(e) {
                let x = e.offsetX;
                let y = e.offsetY;
                let colorData = this.ctx.getImageData(x, y, 1, 1).data;

                let r =  colorData[0];
                let g =  colorData[1];
                let b =  colorData[2]

                this.rgbColor = {
                    rgb: `rgb(${r}, ${g}, ${b})`,
                    r,
                    g,
                    b
                }
                this.hexColor = this.fullColorHex(r, g, b);
                this.hslColor = {
                    h: this.rgbToHsl(r, g, b).h,
                    s: this.rgbToHsl(r, g, b).s,
                    l: this.rgbToHsl(r, g, b).l
                }
                this.hueColor = this.hslToRgb(this.hslColor.h, 1, .5);
                this.pointerPos = {
                    x,
                    y
                },
                this.$store.dispatch('SET_PAGE_COLOR', {
                    rgb: this.rgbColor.rgb,
                    hex: this.hexColor,
                    X: Math.round(this.pointerPos.x),
                    Y: Math.round(this.pointerPos.y)
                })
            },
            onInputChange() {
                this.rgbColor = this.hexToRgb(this.hexColor)

                this.hslColor = {
                    h: this.rgbToHsl(this.rgbColor.r, this.rgbColor.g, this.rgbColor.b).h,
                    s: this.rgbToHsl(this.rgbColor.r, this.rgbColor.g, this.rgbColor.b).s,
                    l: this.rgbToHsl(this.rgbColor.r, this.rgbColor.g, this.rgbColor.b).l
                }
                this.ctx.clearRect(0, 0, this.width, this.height);
                this.renderHSL(this.ctx, this.hslColor.h, this.width, this.height);
                this.pointerPos = {
                    x: this.getDotCoordinates(this.hslColor.s, this.hslColor.l, this.width, this.height).x,
                    y: this.getDotCoordinates(this.hslColor.s, this.hslColor.l, this.width, this.height).y
                }

                this.$store.dispatch('SET_PAGE_COLOR', {
                    rgb: this.rgbColor.rgb,
                    hex: this.hexColor,
                    X: Math.round(this.pointerPos.x),
                    Y: Math.round(this.pointerPos.y)
                })
            },
            onRgbInputChange(rgbColor, color) {
                if (color === 'red') {
                    this.rgbColor.r = rgbColor;
                } else if (color === 'green') {
                    this.rgbColor.g = rgbColor;
                } else {
                    this.rgbColor.b = rgbColor;
                }

                this.rgbColor.rgb = `rgb(${this.rgbColor.r}, ${this.rgbColor.g}, ${this.rgbColor.b})`
                
                this.hexColor = this.fullColorHex(this.rgbColor.r, this.rgbColor.g, this.rgbColor.b);

                this.hslColor = {
                    h: this.rgbToHsl(this.rgbColor.r, this.rgbColor.g, this.rgbColor.b).h,
                    s: this.rgbToHsl(this.rgbColor.r, this.rgbColor.g, this.rgbColor.b).s,
                    l: this.rgbToHsl(this.rgbColor.r, this.rgbColor.g, this.rgbColor.b).l
                }
                this.ctx.clearRect(0, 0, this.width, this.height);
                this.renderHSL(this.ctx, this.hslColor.h, this.width, this.height);
                this.pointerPos = {
                    x: this.getDotCoordinates(this.hslColor.s, this.hslColor.l, this.width, this.height).x,
                    y: this.getDotCoordinates(this.hslColor.s, this.hslColor.l, this.width, this.height).y
                }

                this.$store.dispatch('SET_PAGE_COLOR', {
                    rgb: this.rgbColor.rgb,
                    hex: this.hexColor,
                    X: Math.round(this.pointerPos.x),
                    Y: Math.round(this.pointerPos.y)
                })
            },
            mousedown(event) {
                this.isDragActive = true;
            },
            mousemove(event) {
                if (this.isDragActive) {
                    // this.changeInputColor(event)
                }
            },
            mouseup(event) {
                if (this.isDragActive) {
                    this.isDragActive = false;
                }
            }
        },
        computed: {
            ...mapGetters([
                'getPages'
            ]),
            getPageColor() {
                return this.getPages.find(page => page.content.id === this.pageId).content.pageColor;
            }
        },
        watch: {
            'rgbColor': {
                deep: true,
                handler() {
                    // console.log('watch')
                }
            },
            'getActivePage': {
                deep: true,
                handler() {
                    this.ctx = this.$refs.colorPickerBlock.getContext('2d')
                    this.hexColor = this.getPageColor.hex;
                    this.rgbColor.rgb = this.getPageColor.rgb;
                    // get red green blue values from rgb string
                    let sep = this.getPageColor.rgb.indexOf(",") > -1 ? "," : " ";
                    let rgb = this.getPageColor.rgb.substr(4).split(")")[0].split(sep);
                    this.rgbColor = {
                        ...this.rgbColor,
                        r: parseInt(rgb[0]),
                        g: parseInt(rgb[1]),
                        b: parseInt(rgb[2])
                    }
                    this.hslColor = this.rgbToHsl(this.rgbColor.r, this.rgbColor.g, this.rgbColor.b)
                    this.hueColor = this.hslToRgb(this.hslColor.h, 1, .5);
                    this.ctx.clearRect(0, 0, this.width, this.height);
                    this.renderHSL(this.ctx, this.hslColor.h, this.width, this.height);
                    this.pointerPos = {
                        x: this.getPageColor.X,
                        y: this.getPageColor.Y
                    }

                    this.createColorPickerSpectrum();
                }
            }
        },
        mounted() {
            this.ctx = this.$refs.colorPickerBlock.getContext('2d')
            this.hexColor = this.getPageColor.hex;
            this.rgbColor.rgb = this.getPageColor.rgb;
            // get red green blue values from rgb string
            let sep = this.getPageColor.rgb.indexOf(",") > -1 ? "," : " ";
            let rgb = this.getPageColor.rgb.substr(4).split(")")[0].split(sep);
            this.rgbColor = {
                ...this.rgbColor,
                r: parseInt(rgb[0]),
                g: parseInt(rgb[1]),
                b: parseInt(rgb[2])
            }
            this.hslColor = this.rgbToHsl(this.rgbColor.r, this.rgbColor.g, this.rgbColor.b)
            this.hueColor = this.hslToRgb(this.hslColor.h, 1, .5);
            this.ctx.clearRect(0, 0, this.width, this.height);
            this.renderHSL(this.ctx, this.hslColor.h, this.width, this.height);
            this.pointerPos = {
                x: this.getPageColor.X,
                y: this.getPageColor.Y
            }

            this.createColorPickerSpectrum();
        },
        props: ['pageId']
    }
</script>

<style lang="scss" scoped>
    .color_picker {
        width: 100%;
        position: relative;
        font-size: 12px;
        margin: 0;
        
    }
    .color_picker > div {
        position: relative;
        width: 100%;
        // background-color: #EFEFEF;
        // border: 1px solid #D4D4D4;
        // border-radius: 3px;
        box-sizing: border-box;
    }
    .color_picker-trigger {
        display: flex;
        align-items: center;
        padding: 5px 8px;
        cursor: pointer;
        text-transform: uppercase;
        z-index: 1000;
        background-color: #FFF;
        border: 1px solid #D4D4D4;
        border-radius: 3px;
        position: relative;
    }
    .color_picker-trigger.active {
        border-bottom: 1px solid #FFF;
        border-radius: 3px 3px 0 0;
    }
    .color_picker-container {
        padding: 15px 0 0 0;
        position: absolute;
        background-color: #FFF;
        width: 200px;
        border-radius: 0 0 3px 3px;
        border: 1px solid #D4D4D4;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        z-index: 10;
        top: 26px;
    }
    #picker_size {
        // width: 90%;
        margin: 0 auto;
        position: relative;
    }
    #color_picker-pointer {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        border: 2px white solid;
        position: absolute;
        background: transparent;
        transform: translate(-50%, -50%);
        z-index: 2;
        box-shadow: 0 0 5px 2px rgba(0, 0, 0, .05), 1px 1px 3px 1px rgba(0, 0, 0, .15);
        cursor: pointer;
    }
    #color_picker-block {
        width: 100%;
    }
    #color_picker-spectrum,
    #color_picker-block {
        border-radius: 3px;
        // margin: 0 auto 5px;
        display: block;
    }
    #spectrum_size {
        margin: 8px auto;
    }
    .color_picker-values {
        margin: 10px auto;
    }
    .color_picker-values input {
        // max-width: 100%;
        width: 90%;
        color: #656565;
        padding: 3px;
        background-color: #EFEFEF;
        border: 1px solid #D4D4D4;
        border-radius: 4px;
    }
    .hex_input {
        margin-bottom: 10px;
    }
    .hex_input,
    .rgb_input,
    .rgb_input > span {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .hex_input > span {
        margin-right: 5px;
    }
    .rgb_input > span {
        width: 30%;
    }
    .rgb_input > span > input {
        margin-left: 5px;
    }
    .rgb_input input::-webkit-outer-spin-button,
    .rgb_input input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>